/**
 * ĐĂNG XUẤT PHẢI XOÁ SẠCH MỌI THỨ CỦA NGƯỜI TRƯỚC — biến, dữ liệu nạp riêng, bản nháp đang gõ, bộ
 * lọc. Máy dùng chung giữa các ca: sót lại một thứ là người sau nhìn thấy kênh, tiền hay hồ sơ của
 * người trước.
 *
 * Store nào giữ dữ liệu theo người dùng thì tự đăng ký hàm dọn ở đây; `session-store` gọi tất cả
 * mỗi khi phiên kết thúc (đăng xuất hoặc hết hạn). Nhờ vậy thêm store mới không phải nhớ sửa chỗ
 * đăng xuất.
 */
type Reset = () => void;
const resets = new Set<Reset>();

export function registerSessionReset(reset: Reset): void {
  resets.add(reset);
}

export function runSessionResets(): void {
  resets.forEach((reset) => reset());
}
